import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/features/auth'

// 路由级角色守卫（组件仍由同目录 index.lazy.tsx 懒加载提供）。
// 侧边栏按角色隐藏菜单，但不能阻止普通登录用户直接敲 URL —— 这里做兜底拦截。
export const Route = createFileRoute('/_authenticated/prompts/')({
  beforeLoad: () => {
    const { auth } = useAuthStore.getState()
    if (auth.user?.role !== 'admin' && auth.user?.role !== 'super_admin') {
      throw redirect({ to: '/403' })
    }
  },
})
